















import Vue from 'vue'
import _ from 'lodash'
export default Vue.extend({
  name: 'StringInput',
  props: {
    name: {},
    value: String,
    placeholder: {},
    suffixIcon: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    type: {type: String, default: 'text'},
    rows: Number
  },
  methods: {
    onBlur (event: UIEvent) {
      // @ts-ignore
      this.$emit('blur', _.trim(event as string))
    },
    onInput (event: string) {
      // @ts-ignore
      this.$emit('input', _.trim(event as string))
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    }
  }
})
